import { v4 } from 'uuid';
import { Answer } from '../interfaces';

function createAnswer(value: any, collectionItemId?: string): Answer {
  return { id: v4(), answeredAt: new Date(), content: value, collectionItemId };
}

export { createAnswer };
